// Profile of Nikolai Genov, Dutch. Source of the profile page.
module.exports = {
  headline: 'AI & Data Science Lead • Healthcare, Life Sciences, Finance',
  summary: 'Gepromoveerd bio-informaticus en technisch lead die AI-ondersteunde softwareontwikkeling combineert met analytics in gereguleerde omgevingen in de gezondheidszorg, life sciences en de financiële sector. Expertise in LLM-/RAG-systemen, MCP-integratie, klinische data, bankprognoses met een horizon tot vijf jaar en geautomatiseerde Excel-rapportage. Combineert R-/Python-ontwikkeling met teamcoördinatie, kwaliteitsborging en workshops op directieniveau; AI Act-certificering en GCP-training.',
  imageAlt: 'Portret van Nikolai Genov',
  personal: {
    position: 'Medeoprichter en directeur van pAIoneer Labs GmbH, directeur van Leap Dynamics GmbH',
    location: 'Berlijn, Duitsland',
    languages: 'Duits en Engels (vloeiend), Bulgaars (vloeiend)',
    programmingLanguages: 'R, Python, SQL/SQLite, SAS, MATLAB',
    certifications: 'AI Act-certificering, GCP-training (2025)',
    publications: 'Peer-reviewed publicaties in Scientific Reports, PLOS Biology, IJMS, Frontiers in Physiology en PLOS ONE'
  },
  education: [
    {
      period: '2021',
      field: 'Promotie: bio-informatica / theoretische biologie',
      institution: '',
      degree: 'Diploma: PhD (Dr. rer. nat.)'
    },
    {
      period: '2015',
      field: 'Studie: bio-informatica',
      institution: 'Freie Universität Berlin',
      degree: 'Diploma: M.Sc. bio-informatica'
    },
    {
      period: '2012',
      field: 'Studie: bio-informatica',
      institution: 'Freie Universität Berlin',
      degree: 'Diploma: B.Sc. bio-informatica'
    }
  ],
  skills: [
    {
      title: 'Kerncompetenties',
      description: 'AI-ondersteunde ontwikkeling, R/Python, LLM/RAG & MCP, klinische data & bio-informatica, prognoses & stresstests, Excel-rapportage, Shiny, technisch leiderschap'
    },
    {
      title: 'Programmeren & analytics',
      description: 'R, Python, SQL/SQLite, SAS, MATLAB; ggplot2, scikit-learn, Keras/TensorFlow'
    },
    {
      title: 'Applicaties & rapportage',
      description: 'R Shiny, Streamlit, Tableau, Leaflet, R Markdown, knitr, LaTeX; geautomatiseerde Excel-/Word-/PDF-rapportage'
    },
    {
      title: 'AI & integratie',
      description: 'OpenCode, ChatGPT, Model Context Protocol (MCP); Ollama, vLLM, LM Studio, Open WebUI, RAG, n8n, Flowise; AI-ondersteunde ontwikkeling met menselijke controle'
    },
    {
      title: 'Engineering',
      description: 'Azure DevOps, GitLab CI/CD, Docker, Camunda, Linux, Microsoft Azure, Google Cloud Platform'
    },
    {
      title: 'Bio-informatica',
      description: 'RNA-seq, microarray, alternatieve splicing/isovormen, gene set enrichment, pathway-/netwerkanalyse, genoomassemblage, overlevingsanalyse; Bioconductor, Cytoscape, GEO, ArrayExpress, Ensembl BioMart, UniProt/Swiss-Prot, GO, Reactome, KEGG, BioGRID, STRING, ChEMBL'
    },
    {
      title: 'Klinische data',
      description: 'EDC, CRF, edit checks, DMP, datavalidatieplannen, UAT, SAE-reconciliatie; CDISC SDTM/ADaM, RAW-/SDTM-/ADaM-pipelines, QC'
    }
  ],
  positions: [
    {
      period: '2022 - april 2024',
      title: 'Rapportage-automatisering, T-Systems / Europese Centrale Bank (ECB)',
      description: [
        'Ontwikkeling van een R-bibliotheek voor statistische rapportage over financiële tijdreeksen; migratie van FAME-logica naar R/Python met Reticulate en geautomatiseerde Word-/PDF-uitvoer.',
        'Pipelines voor het geautomatiseerd aanmaken van Excel-rapporten; integratie van analytics met Camunda en ondersteuning van GitLab CI/CD, unittests, linting, SonarQube en technische documentatie.',
        'Plaatsvervanger van de teamleider; bijdragen aan sprintplanning, technische coördinatie, kwaliteitsborging en afstemming met stakeholders.'
      ]
    },
    {
      period: 'juni 2025 - december 2025',
      title: 'Data Science & Risk Analytics Consultant, bankwezen',
      description: [
        'Ontwikkeling van prognosemodellen met planningshorizonten tot vijf jaar en implementatie van stresstests.',
        'Herschrijven en refactoren van bestaande R-code en optimalisatie van vier bedrijfsprocessen; AI-ondersteunde ontwikkeling met menselijke controle voor implementatie en documentatie.',
        'R-/Shiny-analyseworkflows en pipelines voor het geautomatiseerd aanmaken van Excel-rapporten; vertaling van zakelijke eisen naar analytische implementaties.'
      ]
    },
    {
      period: 'juni 2025 - juni 2026',
      title: 'Clinical Data Manager, farma / klinische studies',
      description: [
        'EDC-setup, CRF-ontwerp, edit checks, gebruikersrollen, specificaties voor gegevensoverdracht en UAT; coördinatie met CRO’s, laboratoria en studieteams.',
        'Opstellen en reviewen van DMP’s, validatieplannen, SAE-reconciliatieplannen en UAT-documentatie; ontwikkeling van R-gebaseerde validatieworkflows en Shiny-applicaties in een GCP-relevante omgeving.'
      ]
    },
    {
      period: 'juli 2026',
      title: 'Klinische datapipeline, Dr. Falk Pharma',
      description: [
        'RAW-/SDTM-/ADaM-analysepipeline in R met OpenCode en AI-ondersteunde ontwikkeling, met validatie, QC, traceerbaarheid en geautomatiseerde Excel-rapportpipelines.'
      ]
    },
    {
      period: '2026',
      title: 'AI-ondersteunde audit-trail-rapportage, Miltenyi Biotec',
      description: [
        'Implementatie van audit-trail-rapporten en geautomatiseerde Excel-rapportpipelines met OpenCode en AI-ondersteunde ontwikkeling, inclusief rapportlogica, debugging, documentatie en menselijke controle.'
      ]
    },
    {
      period: '2019 - heden',
      title: 'Directeur & medeoprichter / AI & Data Lead, Leap Dynamics GmbH',
      description: [
        'Leiding over advies en technische realisatie in de gezondheidszorg, life sciences, de financiële sector en AI; eigen ontwikkelwerk gecombineerd met teamcoördinatie en stakeholdercommunicatie.',
        'Ontwerp van LLM-/RAG-infrastructuur en MCP-gebaseerde toolintegratie; opzet van OpenCode-ondersteunde R-/Python-workflows voor codegeneratie, refactoring, testen en documentatie met menselijke controle.'
      ]
    },
    {
      period: '2022 - heden',
      title: 'Kankerregistratie & biobank, Medical University Pleven',
      description: [
        'Analyse van nationale kankerregistratiegegevens en Shiny-dashboards voor klinische en wetenschappelijke stakeholders; ondersteuning van data-integratie, documentatie en biobankworkflows voor vijf kankersoorten.'
      ]
    },
    {
      period: '2025 - heden',
      title: 'Lead Developer, AI Map Europe (ai-map.eu)',
      description: [
        'Productierijpe R Shiny-applicatie; migratie van CSV-gegevens naar SQLite, admin-login, beheer van instituten, bezoekersanalyses, betaalde vermeldingen en aanvraagformulieren met SMTP-meldingen.',
        'Verbetering van responsieve UI/UX, SEO, gestructureerde data en sitemap/robots; invoervalidatie, output-escaping, login-throttling en uitsluitend geverifieerde openbare records. Controle van 400+ instituten aan de hand van ELLIS, CAIRNE, AI NATION, NET4AI, INSAIT en AI-on-Demand, met documentatie over herkomst, verificatie, deployment en beveiliging.'
      ]
    },
    {
      period: '2024 - heden',
      title: 'LLM-gebaseerde analyse van financieel nieuws, Leap Dynamics (intern project)',
      description: [
        'Terugkerende sentimentanalyses met LLM’s, API-gegevens, geautomatiseerde PDF-rapporten, een Streamlit-interface, n8n-orkestratie en Flowise-ondersteunde workflowtests.'
      ]
    },
    {
      period: '2025',
      title: 'Workshops op directieniveau, BVMW',
      description: [
        'Verzorgen van workshops voor deelnemers op directieniveau binnen het BVMW-netwerk.'
      ]
    },
    {
      period: '2015 - 2019',
      title: 'Wetenschappelijk medewerker, Humboldt-Universität / Charité, Berlijn',
      description: []
    },
    {
      period: '2015 - 2017',
      title: 'CTO & medeoprichter, Promethano GmbH',
      description: [
        'Software en tijdreekstoepassingen voor life sciences.'
      ]
    }
  ]
};
